import axios from 'axios'
import FileSaver from 'file-saver'
import JSZip from 'jszip'

import type { ProductionHistoryRecord } from './assistant-models'

function getDownloadFileName(record: ProductionHistoryRecord): string {
  const fileName = record.name || record.id
  const urlFileName =
    record.downloadUrl?.split(/[?#]/)[0].split('/').pop() || ''
  const extension = urlFileName.match(/\.[a-zA-Z0-9]+$/)?.[0]
  return extension && !/\.[a-zA-Z0-9]+$/.test(fileName)
    ? `${fileName}${extension}`
    : fileName
}

export async function downloadSelectedProductionFiles(
  records: ProductionHistoryRecord[]
): Promise<{ downloaded: number; failed: string[] }> {
  const zip = new JSZip()
  let downloaded = 0
  const directoryNames = new Set<string>()
  const directoryNamesByRecordId = new Map<string, string>()
  records.forEach((record) => {
    const name = record.name || record.id
    const directoryName = directoryNames.has(name)
      ? `${name}_${record.id}`
      : name
    directoryNames.add(directoryName)
    directoryNamesByRecordId.set(record.id, directoryName)
  })
  const failed: string[] = []
  await Promise.all(
    records.map(async (record) => {
      if (!record.downloadUrl) {
        failed.push(record.name)
        return
      }
      try {
        const response = await axios.get<ArrayBuffer>(record.downloadUrl, {
          responseType: 'arraybuffer',
        })
        zip.file(
          `${directoryNamesByRecordId.get(record.id)}/${getDownloadFileName(
            record
          )}`,
          response.data
        )
        downloaded += 1
      } catch {
        failed.push(record.name)
      }
    })
  )
  if (downloaded) {
    FileSaver.saveAs(await zip.generateAsync({ type: 'blob' }), '生产文件.zip')
  }
  return { downloaded, failed }
}
